import { render, staticRenderFns } from "./AppointmentsConfirmationModal.vue?vue&type=template&id=db11973c&scoped=true&"
import script from "./AppointmentsConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db11973c",
  null
  
)

export default component.exports